export default {
  fr: {
    minimal: {
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      // weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    },
    precise: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      // weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    }
  },
  en: {
    minimal: {
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      // weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    },
    precise: {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      // weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/dateTimeFormats.js